// @ts-check
import angular from "angular";
import certificationIcon from "./certification-icon.html";
import "./certification-icon.css";

export default angular
  .module("certificationIconComponent", [])
  .component("certificationIcon", {
    template: certificationIcon,
    controller: function () {},
    bindings: {
      icon: "=",
      tooltipClass: "@?", // Optional binding for custom css class for the tooltip
    },
    controllerAs: "$ctrl",
  });
